// ManageSite.jsx
import React from 'react';
import { useOutletContext, Link } from 'react-router-dom';

const ManageSite = () => {
  const { isOrderingEnabled } = useOutletContext();

  return (
    <div className="bg-white shadow-lg rounded-2xl p-4 sm:p-6 text-candy-text border border-candy-border">
      <h1 className="text-xl sm:text-2xl font-bold mb-6 flex items-center gap-2">
        🛰️ Manage Client Site
      </h1>

      {/* Ordering status + settings */}
      <div className="mb-8">
        <p className="mb-4">
          Current status: {isOrderingEnabled ? '✅ Accepting Orders' : '❌ Not Accepting Orders'}
        </p>
        <Link
          to="/Taylor/settings"
          className="inline-block px-4 py-2 rounded-lg bg-candy-primary text-white hover:bg-candy-primaryDark transition"
        >
          Change in Settings →
        </Link>
      </div>

      <hr className="border-candy-border/60 my-6" />

      {/* Gallery management */}
      <div className="space-y-3">
        <h2 className="text-lg sm:text-xl font-semibold flex items-center gap-2">
          📸 Manage Gallery
        </h2>
        <p className="text-sm text-gray-600">
          Add or edit cakes, upload 2–3+ images per design, reorder items, and toggle visibility.
        </p>
        <Link
          to="/Taylor/gallery"
          className="inline-block px-4 py-2 rounded-lg bg-candy-primary text-white hover:bg-candy-primaryDark transition"
        >
          Open Gallery Manager →
        </Link>
      </div>
    </div>
  );
};

export default ManageSite;
